<div class="container-box">
  <app-table-header tableTitle="Garanzia" (btnUpdateClick)="loadWarranties()">
    <app-button-new-warranty action-button></app-button-new-warranty>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="warrantiesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
